import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import img from '../img/image.png'
import { fetchContractProduction, fetchContractProductionPoints } from '../strapi';
import { useState, useEffect } from 'react'
import Markdown from 'react-markdown'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';

function ContractProduction({ locale }) {
    const [text, setText] = useState({});
    const [texts, setTexts] = useState([])
    useEffect(() => {
        fetchContractProduction(locale)
            .then(data => {
                setText(data.data);
                setTexts(data.dataA);
                // console.log(data)
            })
            .catch(err => {
            });
    }, [locale]);

    // useEffect(() => {
    //     fetchContractProductionPoints(locale)
    //         .then(data => {
    //             setTexts(data);
    //             console.log(data)
    //         })
    //         .catch(err => {
    //         });
    // }, [locale]);

    return (
        <div >
            {/* Mobile adaptation: Responsive paddings, font sizes, and layout */}
            <Box
                sx={{
                    width: '100%',
                    bgcolor: { xs: '#fff', md: 'transparent' },
                    px: { xs: 0, md: 0 },
                }}
            >
                <Container
                    maxWidth="md"
                    sx={{
                        px: { xs: 1, sm: 2, md: 3 },
                        py: { xs: 2, md: 4 },
                    }}
                >
                    <Typography
                        className='titleOfPage'
                        component="div"
                        sx={{
                            mt: { xs: 2, xl: '60px' },
                            pt: { xs: '60px', xl: '' },
                            fontSize: { xs: '28px', sm: '32px', md: '40px' },
                            fontWeight: 'bold',
                            textAlign: { xs: 'center', md: 'left' },
                        }}
                    >
                        {text?.title}
                    </Typography>
                    <Typography
                        className='mainText'
                        component='div'
                        sx={{
                            fontSize: { xs: '15px', sm: '16px', md: '18px' },
                            mt: { xs: 2, md: 3 },
                            textAlign: { xs: 'justify', md: 'left' },
                        }}
                    >
                        <Markdown>{text?.text}</Markdown>
                    </Typography>
                    {texts != null && texts.map((item, index) =>
                        <Box key={index} sx={{ mb: { xs: 4, md: 6 } }}>
                            <Stack
                                direction="row"
                                alignItems="center"
                                mt={{ xs: '24px', md: '40px' }}
                                mb={{ xs: '10px', md: '20px' }}
                                spacing={2}
                            >
                                <Box
                                    bgcolor='#E1EEFF'
                                    borderRadius='50px'
                                    minWidth={{ xs: '36px', md: '50px' }}
                                    height={{ xs: '36px', md: '50px' }}
                                    p={1}
                                    m={1}
                                    textAlign='center'
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Typography
                                        className='titleOfParagraph'
                                        lineHeight={{ xs: '36px', md: '50px' }}
                                        sx={{
                                            fontSize: { xs: '18px', md: '24px' },
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {index + 1}
                                    </Typography>
                                </Box>
                                <Typography
                                    className='titleOfParagraph'
                                    sx={{
                                        fontSize: { xs: '18px', md: '32px' },
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {item.name}
                                </Typography>
                            </Stack>
                            <Typography
                                className='mainText'
                                component='div'
                                sx={{
                                    ml: { xs: 0, md: '80px' },
                                    fontSize: { xs: '15px', sm: '16px', md: '18px' },
                                    textAlign: { xs: 'justify', md: 'left' },
                                }}
                            >
                                <Markdown>{item.text}</Markdown>
                            </Typography>
                            {item.images != null && item.images.length > 0 && (
                                <Box
                                    textAlign='center'
                                    p={{ xs: '10px', md: '30px' }}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: { xs: 2, sm: 3 },
                                    }}
                                >
                                    {item.images.map((imgItem, imgIdx) =>
                                        <img
                                            key={imgIdx}
                                            alt='img'
                                            src={imgItem.url}
                                            className='articleimg'
                                            style={{
                                                maxWidth: '100%',
                                                width: '100%',
                                                height: 'auto',
                                                borderRadius: 8,
                                                marginBottom: 8,
                                                objectFit: 'cover'
                                            }}
                                        />
                                    )}
                                </Box>
                            )}
                        </Box>
                    )}
                </Container>
            </Box>
            {/* <Container>
                <Typography className='titleOfPage' component="div" sx={{ mt: { xs: '', xl: '60px' }, pt: { xs: '80px', xl: '' } }}>{text?.title}</Typography>
                <Typography className='mainText' component='div'><Markdown>{text?.text}</Markdown></Typography>
                {texts != null && texts.map((item, index) =>
                    <div key={index}>
                        <Stack key={index} direction={'row'} alignItems='center' mt={'40px'} mb={'20px'}>
                            <Box bgcolor='#E1EEFF' borderRadius='50px' minWidth='50px' height='50px' p={1} m={1} textAlign={'center'} alignItems={'center'}>
                                <Typography className='titleOfParagraph' lineHeight='50px'>{index + 1}</Typography>
                            </Box>
                            <Typography className='titleOfParagraph'>{item.name}</Typography>
                        </Stack>
                        <Typography className='mainText' component='div' ml='80px'><Markdown >{item.text}</Markdown></Typography>

                        <Box textAlign={'center'} p={'30px'}>
                            {item.images != null && item.images.map((item, index) =>
                                <img alt='img' src={item.url} className='articleimg'></img>
                            )}
                        </Box>
                    </div>
                )}

            </Container> */}
        </div>
    );
}

export default ContractProduction;
